import { css } from 'styled-components';

export const CTABasics = css`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;

  .text,
  .iconBefore,
  .iconAfter {
    position: relative;
    z-index: 2;
  }

  .iconBefore {
    margin-right: 10px;
  }

  &:disabled {
    cursor: not-allowed;
    background: ${(props) => props.theme.color.gray50};
    color: ${(props) => props.theme.color.gray500};

    .iconAfter {
      color: ${(props) => props.theme.color.gray500};
    }
  }

  &:disabled:hover {
    opacity: 1;
    background: ${(props) => props.theme.color.gray50};
    color: ${(props) => props.theme.color.gray500};
  }

  &:disabled:before {
    background: none;
  }

  span + span {
    margin-top: 0;
  }
`;

export const CTAAnimationBasics = css`
  gap: 14px;
`;

export const CTACommonBeforeStyles = css`
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scaleX(0);
  transform-origin: right center;
  transition: transform 0.15s cubic-bezier(0.45, 0.05, 0.3, 0.95) 0.15s;
  z-index: 1;
`;
